<script>
  import DialogBase from "./DialogBase.svelte";
  import Notifications from "svelte-notifications";
  import NotificationBase from "../notification/NotificationBase.svelte";

  export let dialog
  export let width = "500px"
  export let onClose = null

  function onClickDialog(event) {
    if (event.target === dialog && onClose) {
      onClose()
    }
  }
</script>

<DialogBase bind:dialog={dialog} width={width} onClick={onClickDialog}>
  <Notifications item={NotificationBase}>
    <slot/>
  </Notifications>
</DialogBase>
